/**
 * In-memory store for legacy mystaff bearer tokens and the admin JWT (PT-033).
 *
 * These tokens authorize privileged backend calls (incl. admin `listUsers`,
 * which returns employee PII) that live outside Firebase Auth. Previously they
 * were kept in `localStorage`, where any script in the origin could read them,
 * so an XSS or a malicious dependency could exfiltrate them. Holding them only
 * in module memory removes that web-storage exposure.
 *
 * Trade-off: a legacy mystaff-only session no longer survives a full page
 * reload. Firebase-auth sessions (the primary path) are unaffected, as Firebase
 * persists its own session outside these keys.
 */
let accessToken = null
let refreshToken = null
let adminAccessToken = null

const mystaffTokens = {
  /** @returns {?string} */
  getAccess: () => accessToken,
  /** @param {?string} value */
  setAccess: (value) => { accessToken = value ?? null },
  /** @returns {?string} */
  getRefresh: () => refreshToken,
  /** @param {?string} value */
  setRefresh: (value) => { refreshToken = value ?? null },
  /** @returns {?string} */
  getAdminAccess: () => adminAccessToken,
  /** @param {?string} value */
  setAdminAccess: (value) => { adminAccessToken = value ?? null },
  /** Clears the employee / legacy session tokens. */
  clearAccess: () => { accessToken = null; refreshToken = null },
  /** Clears the admin JWT. */
  clearAdminAccess: () => { adminAccessToken = null }
}

export default mystaffTokens
